// @flow
import React from 'react';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { ProductProgram } from 'Components/widgets/product-program/ProductProgram.jsx';
import { type LineProps } from 'Client/cms/toolkit/cruise-program/cruiseProgram.resolver';

export const CruiseProgramLine = ({
  id,
  isDetailed,
  cruise: { stopover = {} } = {},
}: LineProps) => {
  return (
    <div className="Line Line-Cruise-Program" id={id}>
      <SiteContainer>
        <ProductProgram isDetailed={isDetailed} program={stopover} />
      </SiteContainer>
    </div>
  );
};
